import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function UsersBulkIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.9508 14.5399C8.5008 14.5399 5.58984 15.1037 5.58984 17.2794C5.58984 19.4561 8.5196 20 11.9508 20C15.4008 20 18.3117 19.4362 18.3117 17.2605C18.3117 15.0839 15.382 14.5399 11.9508 14.5399Z"
        fill="currentColor"
      />
      <path
        opacity="0.4"
        d="M11.9476 12.467C14.2837 12.467 16.1569 10.5831 16.1569 8.23351C16.1569 5.88306 14.2837 4 11.9476 4C9.61146 4 7.73828 5.88306 7.73828 8.23351C7.73828 10.5831 9.61146 12.467 11.9476 12.467Z"
        fill="currentColor"
      />
      <path
        opacity="0.4"
        d="M21.0886 9.21923C21.693 6.84176 19.9209 4.70654 17.6645 4.70654C17.4192 4.70654 17.1846 4.73356 16.9554 4.77949C16.9249 4.78669 16.8909 4.802 16.873 4.82902C16.8524 4.86324 16.8676 4.90917 16.89 4.93889C17.5678 5.89528 17.9573 7.0597 17.9573 8.30967C17.9573 9.50741 17.6001 10.6241 16.9733 11.5508C16.9088 11.6462 16.9661 11.775 17.0798 11.7948C17.2374 11.8227 17.3986 11.8371 17.5634 11.8416C19.2064 11.8849 20.6811 10.8213 21.0886 9.21923Z"
        fill="currentColor"
      />
      <path
        d="M22.8094 14.817C22.5086 14.1722 21.7824 13.73 20.6783 13.513C20.1572 13.3851 18.747 13.205 17.4352 13.2293C17.4155 13.232 17.4048 13.2455 17.403 13.2545C17.4003 13.2671 17.4057 13.2887 17.4316 13.3022C18.0378 13.6039 20.3811 14.916 20.0865 17.6834C20.074 17.8032 20.1698 17.9068 20.2888 17.8888C20.8655 17.8059 22.3492 17.4853 22.8094 16.4866C23.0637 15.9589 23.0637 15.3456 22.8094 14.817Z"
        fill="currentColor"
      />
      <path
        opacity="0.4"
        d="M7.04508 4.77973C6.81675 4.7329 6.58126 4.70679 6.33592 4.70679C4.0795 4.70679 2.3075 6.84201 2.91279 9.21947C3.31931 10.8216 4.79403 11.8851 6.4371 11.8419C6.60185 11.8374 6.76392 11.8221 6.92061 11.7951C7.03433 11.7753 7.09164 11.6465 7.02717 11.551C6.40039 10.6234 6.04312 9.50765 6.04312 8.30991C6.04312 7.05904 6.43352 5.89462 7.11134 4.93913C7.13283 4.90941 7.14894 4.86348 7.12745 4.82926C7.10954 4.80135 7.07642 4.78694 7.04508 4.77973Z"
        fill="currentColor"
      />
      <path
        d="M3.32156 13.5127C2.21752 13.7297 1.49225 14.1719 1.19139 14.8167C0.936203 15.3453 0.936203 15.9586 1.19139 16.4872C1.65163 17.4851 3.13531 17.8066 3.71195 17.8885C3.83104 17.9065 3.92595 17.8038 3.91342 17.6832C3.61883 14.9167 5.9621 13.6046 6.56918 13.3029C6.59425 13.2885 6.59962 13.2677 6.59694 13.2542C6.59515 13.2452 6.5853 13.2317 6.5656 13.2299C5.25294 13.2047 3.84358 13.3848 3.32156 13.5127Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
